// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var AvailabilitySchedule = function (x) {
    return x;
};
var newtypeAvailabilitySchedu = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldAvailabilitySched = function (dictHasField) {
    return dictHasField;
};
var eqAvailabilitySchedule = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Calendar_Types_Availability.eqWeeklyAvailability)(x.availability)(y.availability) && x.name === y.name;
        };
    }
};
var genericAvailabilitySchedule = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showAvailabilitySchedule = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAvailabilitySchedule)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Restaumatic_Calendar_Types_Availability.showWeeklyAvailability))))({
        reflectSymbol: function () {
            return "AvailabilitySchedule";
        }
    }))
};
var unscrambleDecodeAvailabilitySchedule = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericAvailabilitySchedule)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(Restaumatic_Calendar_Types_Availability.decodeWeeklyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeAvailabilitySchedule = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericAvailabilitySchedule)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AvailabilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Calendar_Types_Availability.encodeWeeklyAvailability))))))
};
var decodeAvailabilitySchedule = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericAvailabilitySchedule)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AvailabilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Calendar_Types_Availability.decodeWeeklyAvailability1))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    AvailabilitySchedule,
    genericAvailabilitySchedule,
    eqAvailabilitySchedule,
    showAvailabilitySchedule,
    encodeAvailabilitySchedule,
    decodeAvailabilitySchedule,
    unscrambleDecodeAvailabilitySchedule,
    hasFieldAvailabilitySched,
    newtypeAvailabilitySchedu
};
//# sourceMappingURL=index.js.map
